import ModalComponent from "./elements/modal";
import ModalActionsComponent from "./elements/modal.actions";
import ModalContentComponent from "./elements/modal.content";
import ModalTitleComponent from "./elements/modal.title";
import LoadingModalComponent from "./loading.modal";

const Modal = ModalComponent;
const ModalTitle = ModalTitleComponent;
const ModalActions = ModalActionsComponent;
const ModalContent = ModalContentComponent;
const LoadingModal = LoadingModalComponent;

export { LoadingModal, Modal, ModalActions, ModalContent, ModalTitle };
